export const zfill = (number: number, width: number = 2): string => {
  const numString = String(number);
  return numString.padStart(width, "0");
};

export const calcPercent = (x: number): number => {
  return (x * 100) / window.innerWidth;
};

export const addComma = (n: number | string): string => {
  if (!String(n).length) return String(n);

  let isNegative = false;
  let sn: string;
  if (Number(n) < 0) {
    sn = String(n).substring(1);
    isNegative = true;
  } else {
    sn = String(n);
  }

  let cc = Math.ceil(sn.length / 3) - 1;
  let res = Array(cc + sn.length);

  let i = sn.length - 1;
  let j = res.length - 1;
  let counter = 0;
  while (true) {
    if (j < 0 || i < 0) break;
    if (counter === 3) {
      res[j] = ",";
      j--;
      counter = 0;
      continue;
    }
    res[j] = sn[i];
    counter++;
    j--;
    i--;
  }

  return res.join("") + (isNegative ? "-" : "");
};

export const removeComma = (n: string): string => {
  let n_ = n.split("");
  n_ = n_.filter((l) => l !== ",");
  return n_.join("");
};

export const getExt = (filename: string): string => {
  return filename.substring(filename.lastIndexOf("."));
};
